module.exports = __webpack_public_path__ + "static/media/galerija_2022_0025.9a1e9660.jpg";